<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">Mes documents</div>
    </v-ons-toolbar>

    <div class="content">

      <template v-for="(negoceInfos, negoceIndex) in negoce">
        <v-ons-list-title :key="'title' + negoceIndex" modifier="perflist">{{ negoceInfos.label }}</v-ons-list-title>
        <v-ons-list modifier="noborder perflist" :key="'list-' + negoceIndex">
          <v-ons-list-item v-for="(formItem, formIndex) in negoceInfos.form" modifier="chevron perfsimple" :key="formIndex"
                           tappable @click="showForm(negoceIndex, formIndex)">
            {{ formItem.title }}
          </v-ons-list-item>
        </v-ons-list>
      </template>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';

import { store } from '../store.js';

import AppParamsFormItem from './ParamsFormItem.vue';

export default {
  mixins: [mixinsCommons],
  props: ['pageStack'],
  data() {
    return {
      initInfos: '',
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    negoce() {
      return this.getNegoceAcces(this.data.negoce.list).filter(item => { return item.form; });
    }
  },
  methods: {
    showForm(negoceIndex, formIndex) {
      var negoceInfos = this.negoce[negoceIndex];
      var formItem = negoceInfos.form[formIndex];
      this.pageStack.push({
        extends: AppParamsFormItem,
        data() {
          return {
            formTitle: formItem.title,
            formUrl: formItem.url
          }
        }
      });
      this.sendTrackEvent('form click ' + negoceInfos.id + ' ' + formItem.id);
    }
  },
  created() {
    if(this.initInfos) {
      var path = this.initInfos.split('/');
      var negoceId = path.shift();
      var formId = path.shift();
      if(negoceId !== undefined && formId !== undefined){
        for (let i = 0; i < this.negoce.length; i++) {
          var negoceInfos = this.negoce[i];
          if(negoceInfos.id == negoceId){
            if(negoceInfos.form[formId]){ // by index
              this.showForm(i, formId);
            } else {
              for (let j = 0; j < negoceInfos.form.length; j++) {
                var formItem = negoceInfos.form[j];
                if(formItem.id == formId){ // by id
                  this.showForm(i, j);
                }
              }
            }
          }
        }
      }
    }
  }
}
</script>
